/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesProfileUpdateMarketingEnabledRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileUpdateMarketingEnabledRequest(value) {
    if (!('MarketingEnabled' in value) || value['MarketingEnabled'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestFromJSON(json) {
    return FxIdWebFeaturesProfileUpdateMarketingEnabledRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'MarketingEnabled': json['MarketingEnabled'],
    };
}
export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSON(json) {
    return FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'MarketingEnabled': value['MarketingEnabled'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileUpdateMarketingEnabledRequest.js.map